import { KeyValue } from "@/main/models/common";

export enum SupplierInventoryWarehouseStatusTypes {
	GET_SUPPLIER_INVENTORY_WAREHOUSE_STATUS = "@supplierInventoryWarehouseStatus/GET_SUPPLIER_INVENTORY_WAREHOUSE_STATUS",
	SAVE_SUPPLIER_INVENTORY_WAREHOUSE_STATUS = "@supplierInventoryWarehouseStatus/SAVE_SUPPLIER_INVENTORY_WAREHOUSE_STATUS",
	RESET_REDUCER_SUPPLIER_INVENTORY_WAREHOUSE_STATUS = "@supplierInventoryWarehouseStatus/RESET_REDUCER_SUPPLIER_INVENTORY_WAREHOUSE_STATUS",
}

export interface SupplierInventoryWarehouseStatusState {
	readonly supplierInventoryWarehouseStatus: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetSupplierInventoryWarehouseStatus {
	type: typeof SupplierInventoryWarehouseStatusTypes.GET_SUPPLIER_INVENTORY_WAREHOUSE_STATUS;
}

export interface SaveSupplierInventoryWarehouseStatus {
	type: typeof SupplierInventoryWarehouseStatusTypes.SAVE_SUPPLIER_INVENTORY_WAREHOUSE_STATUS;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerSupplierInventoryWarehouseStatus {
	type: typeof SupplierInventoryWarehouseStatusTypes.RESET_REDUCER_SUPPLIER_INVENTORY_WAREHOUSE_STATUS;
}

export type SupplierInventoryWarehouseStatusActionTypes =
	| GetSupplierInventoryWarehouseStatus
	| SaveSupplierInventoryWarehouseStatus
	| ResetReducerSupplierInventoryWarehouseStatus;
